import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./styles/SimpleModal.css"

const SimpleModal = ({
    isShow,
    title,
    body,
    setShowModal,
    btnTextClose = "FECHAR",
    btnTextAction = "CONFIRMAR",
    btnColorClose = "secondary",
    btnColorAction = "primary",
    btnBodyAction,
    onClickAction,
    INITIAL_MODAL
  }) => {
    return (
      <Modal
        show={isShow}
        onHide={() => setShowModal(INITIAL_MODAL)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{body}</p>
        </Modal.Body>
        {onClickAction && (
          <Modal.Footer
            className="d-flex justify-content-between"
          >
            <Button
              className="btnModal"
              variant={btnColorClose}
              onClick={() => setShowModal(false)}
            >
              {btnTextClose}
            </Button>
            <Button
              className="btnModal"
              variant={btnColorAction}
              onClick={onClickAction}
            >
              {btnBodyAction ? btnBodyAction : btnTextAction}
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    );
};

export default SimpleModal;
